export const payment = {
  button: 'Request an invoice',
  company_name: 'Company name',
  company_name_tooltip: 'Enter the name of the company for which the invoice will be issued.',
  tooltip: 'Choose the currency in which you want to receive an invoice.',
  tooltip_email: 'Select or enter an emails address to which the invoice will be sent.',
  legal_entities: 'This payment method is only available for legal entities.',
  general: 'Main',
  success:
    'We have received your request to create an account. A financial specialist will contact you shortly.',
  asana_api_problems: 'An error has occurred. Try again later.',
  finance_email: 'Financial email',
  email_rates: 'Email for rates',
  email_optional: 'Additional email',
  widget: {
    balance: {
      title: 'Balance {value}',
      button: 'Top up balance'
    },
    modal: {
      title: 'Top up balance',
      no_methods: 'No payment methods available',
      form: {
        field: {
          amount: 'Amount'
        },
        submit: 'Pay',
        minimal_amount: 'Minimum ',
        alert_minimum: 'The specified amount is less than the minimum value.',
        method_message: {
          comepay: '',
          fondy: '',
          invoice_request: '',
          tinkoff: 'Сommission of 2,25% will be deducted',
          webmoney: 'When paying via WebMoney a commission of 3,5% will be deducted',
          yoomoney: 'When paying through ЮMoney, a 5,5% commission will be deducted',
          capitalist: '',
          paypal: 'When paying through PayPal a commission will be deducted'
        }
      }
    }
  },
  errors: {
    check_user_phone: 'According to the requirements of the National Payment Card System for payments from bank cards, you must specify your phone number in your <a href=".">profile</a>'
  }
};
